export default __webpack_public_path__ + "static/media/flag-niger.5984f71c.svg";